/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SendSummaryMailResult {
  AcceptedBidsNotSynchronizedWithInumis = 'accepted_bids_not_synchronized_with_inumis',
  NoEndedPartsFound = 'no_ended_parts_found',
  NoUnsentEndedPartsFound = 'no_unsent_ended_parts_found',
  AuctionHasNonEndedParts = 'auction_has_non_ended_parts',
  AuctionNotFound = 'auction_not_found',
  Success = 'success',
  AuctionFinalSummaryMailAlreadySent = 'auction_final_summary_mail_already_sent',
  ConsignmentResultMailsDisabled = 'consignment_result_mails_disabled',
  NoConsignedLotsFound = 'no_consigned_lots_found'
}
